import {
  ANNUAL_INCOME_OPTIONS,
  FUND_OPTIONS,
  NET_WORTH_OPTIONS,
  RISK_TOLERANCE_OPTIONS,
} from 'consts/kyc/options/kyc';
import AccreditedToggle from 'pages/profile/components/ProfileTabContent/Account/InvestmentProfile/components/AccreditedToggle';
import { InvestmentProfile } from 'types/kyc-identities-types';

export const getInvestmentProfileData = (
  investmentProfile?: InvestmentProfile
) => {
  return [
    {
      key: 'Accredited Investor',
      value: (
        <AccreditedToggle isAccredited={!!investmentProfile?.isAccredited} />
      ),
    },
    {
      key: 'Net Worth',
      value:
        investmentProfile && NET_WORTH_OPTIONS[investmentProfile?.netWorth],
    },
    {
      key: 'Annual Income',
      value:
        investmentProfile &&
        ANNUAL_INCOME_OPTIONS[investmentProfile?.annualIncome],
    },
    {
      key: 'Source of funds',
      value:
        investmentProfile && FUND_OPTIONS[investmentProfile?.howWillYouFund],
    },
    {
      key: 'Risk',
      value:
        investmentProfile &&
        RISK_TOLERANCE_OPTIONS[investmentProfile?.adventurousType],
    },
  ];
};
